import styled from "styled-components";
import colors from "css/colors";
import { Typography } from "antd";

export const SwitchWrapper = styled.div`
  button {
    height: 34px;
  }

  .ant-switch-handle {
    top: 3px;
    width: 28px;
    height: 28px;
    margin-left: 1px;
  }

  .ant-switch-checked .ant-switch-handle {
    left: calc(100% - 18px - 14px);
  }

  .ant-switch-handle::before {
    border-radius: 50%;
  }
  .ant-switch-checked {
    background-color: ${colors.GREEN};
  }
`;

export const TooltipText = styled(Typography.Text)`
  color: ${colors.WHITE};
`;
